import React from 'react'

export const WaitingPanel = () => (
  <div/>
)
